import { render, staticRenderFns } from "./CommissionOrders.vue?vue&type=template&id=485a9dc1&scoped=true&"
import script from "./CommissionOrders.vue?vue&type=script&lang=js&"
export * from "./CommissionOrders.vue?vue&type=script&lang=js&"
import style0 from "./CommissionOrders.vue?vue&type=style&index=0&id=485a9dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a9dc1",
  null
  
)

export default component.exports